import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 9;
const DEFAULT_HEIGHT = 9;

function IconTick({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 9 9">
            <g fill="none" fill-rule="evenodd">
                <g fill={color}>
                    <path d="M4.5 7c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm0-7c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1s-1-.448-1-1V1c0-.552.448-1 1-1z"/>
                </g>
            </g>
        </svg>
    );
}

IconTick.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "#FDBD39"
};

export default IconTick;
